<button type="button" id="profile" class="ev-plain-button profile-outer" data-testid="profile-container" [ngClass]="{'dropdown-visible': dropdownVisible}" (click)="profileClick()">
  @if (!isAuthorized()) {
    <span class="profile-container unauthorized" data-testid="profile-unauthorized-container">
      <img alt="user" class="user-icon-default" [src]="'/assets/icons/' + settingsService.getMap().Skin + '/ui/user_icon.svg'" />
      <img alt="user" class="profile-hamburger-icon" [src]="'/assets/icons/' + settingsService.getMap().Skin + '/ui/profile_hamburger.svg'" />
    </span>
  }
  @if (isAuthorized()) {
    <span class="profile-container authorized" data-testid="profile-authorized-container">
      <span class="profile-username" data-testid="profile-username-text" [ngClass]="{'small-padding': subscriptionType()?.includes('pro.'), 'medium-padding': subscriptionType()?.includes('proplus.') }">{{ username() }}</span>
      @if (subscriptionType()?.includes('pro.')) {
        <img alt="pro" id="pro-badge" data-testid="profile-pro-badge" src="assets/icons/default/ui/PRO_icon.svg"/>
      }
      @if (!avatarLink()) {
        <img alt="user" class="user-icon-default" data-testid="profile-default-avatar-img"
          [src]="'/assets/icons/' + settingsService.getMap().Skin + '/ui/user_icon.svg'" />
      }
      @if (avatarLink()) {
        <img alt="user" class="user-icon" data-testid="profile-avatar-img"
          [src]="avatarLink()" />
      }
      @if (subscriptionType()?.includes('proplus.')) {
        <img alt="proplus" id="proplus-badge" data-testid="profile-proplus-badge" src="assets/icons/default/ui/PROPLUS_icon.svg"/>
      }
      <img alt="user" class="profile-hamburger-icon" [src]="'/assets/icons/' + settingsService.getMap().Skin + '/ui/profile_hamburger.svg'" />
    </span>
  }
</button>
